
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 .028a3 3 0 00-3 3v9a3 3 0 003 3h2.25v1.44c0 1.268 1.475 1.965 2.454 1.159l3.155-2.599H15a3 3 0 003-3v-9a3 3 0 00-3-3H3zm5 5.664a1 1 0 11-2 0 1 1 0 012 0zm4.322 2.17c.51.18.785.747.5 1.206a4.501 4.501 0 01-7.59.086c-.295-.452-.032-1.025.474-1.216.505-.191 1.06.084 1.426.48a2.543 2.543 0 003.775-.042c.357-.405.905-.693 1.415-.513zM11 6.693a1 1 0 100-2 1 1 0 000 2z","fill":"#348EF6"}})])
          )
        }
      }
    